<script setup>
import { getCurrentInstance, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import { DriverStore } from '../pinia/Driver'
import StripeCheckout from './StripeCheckout.vue'
import PaymentPrice from './PaymentPrice.vue'
import benefits from '../configs/premium.json'

const Driver = DriverStore()
const route = useRoute()
const { proxy } = getCurrentInstance()

onMounted(async () => {
  if (route.query.checkout !== 'success' || !route.query.session_id) return
  const result = await proxy.$api({
    serviceName: 'stripeCheckout',
    methodName: 'confirmCheckoutSession',
    parameters: [route.query.session_id],
  })
  if (result?.status === 'ok') Driver.user.premium = '1'
})
</script>

<template><div v-if="Driver.user.premium == '0'" class="settings-tab-page">
    <div v-if="Driver.user.discord == null" class="section-list">
      <div class="section-row"><div class="section-body gate-panel">
        <v-icon size="28">mdi-discord</v-icon>
        <div><strong>Discord required</strong><p>Link Discord on your account before buying Premium.</p></div>
      </div></div>
    </div>
    <div v-else class="buy-layout">
      <div class="section-list"><div class="section-row"><div class="section-body">
        <div class="buy-head"><strong>Premium membership</strong><span class="buy-price"><PaymentPrice item-id="premium" /></span></div>
        <p class="buy-note">One-time payment · lifetime access on your current driver</p>
        <ul class="buy-features">
          <li><v-icon size="14">mdi-check</v-icon> All premium features</li>
          <li><v-icon size="14">mdi-check</v-icon> Instant activation</li>
          <li><v-icon size="14">mdi-check</v-icon> Future premium updates</li>
          <li><v-icon size="14">mdi-check</v-icon> Direct server support</li>
        </ul>
      </div></div></div>
      <div class="payment-section"><StripeCheckout /></div>
    </div>
  </div>
  <div v-else class="settings-tab-page">
    <div class="settings-tab-header"><div class="header-icon"><v-icon>mdi-star-check</v-icon></div><div class="header-content"><h3 class="page-title">Thank you</h3><p class="page-subtitle">Your Premium support keeps the servers running.</p></div></div>
    <div class="section-list">
      <div v-for="benefit in benefits" :key="benefit.title" class="section-row"><div class="section-body benefit-row">
        <div class="benefit-icon"><v-icon size="18">{{ `mdi-${benefit.icone}` }}</v-icon></div>
        <div><strong>{{ benefit.title }}</strong><p v-html="benefit.text" /></div>
      </div></div>
    </div>
  </div></template>

<style scoped>
.gate-panel {
  display:flex;
  align-items:flex-start;
  gap:12px}
.gate-panel strong {
  display:block;
  font-size:.95rem}
.gate-panel p {
  margin:4px 0 0;
  color:var(--mute);
  font-size:.82rem;
  line-height:1.4}
.buy-layout {
  display:flex;
  flex-direction:column;
  gap:12px}
.buy-head {
  display:flex;
  align-items:center;
  justify-content:space-between;
  gap:12px}
.buy-head strong {
  font-size:.95rem}
.buy-price {
  font-size:1.15rem;
  font-weight:800}
.buy-note {
  margin:6px 0 12px;
  color:var(--mute);
  font-size:.78rem}
.buy-features {
  margin:0;
  padding:0;
  list-style:none;
  display:flex;
  flex-direction:column;
  gap:8px}
.buy-features li {
  display:flex;
  align-items:center;
  gap:8px;
  color:var(--ink-soft);
  font-size:.84rem}
.payment-section {
  padding:14px;
  border-radius:10px;
  border:1px solid var(--line);
  background:var(--glass)}
.benefit-row {
  display:flex;
  align-items:flex-start;
  gap:12px}
.benefit-icon {
  display:inline-flex;
  align-items:center;
  justify-content:center;
  flex-shrink:0;
  width:36px;
  height:36px;
  border-radius:9px;
  background:var(--glass-strong)}
.benefit-row strong {
  display:block;
  font-size:.9rem}
.benefit-row p {
  margin:2px 0 0;
  color:var(--mute);
  font-size:.78rem;
  line-height:1.35}
</style>
